import React, {createContext, useContext, useMemo} from "react";
import {IHttpRequestService} from "../services/HttpRequestService";
import {createHttpRequestService} from "./Bootstrap";
import {useApplicationContext} from "./ApplicationContext";

const HttpRequestContext = createContext<IHttpRequestService | null>(null);

export const HttpRequestProvider: React.FC<{children?: React.ReactNode}> =
    ({children}) => {
        const { setValidationMessage } = useApplicationContext();
        
        const httpRequestService = useMemo(() => {
            return createHttpRequestService(setValidationMessage);
        }, [setValidationMessage]);
        
        return (
            <HttpRequestContext.Provider value={httpRequestService}>
                {children}
            </HttpRequestContext.Provider>
        );
};

export const useHttpRequestService = () => {
    const httpRequestService = useContext(HttpRequestContext);
    if (!httpRequestService) {
        throw new Error('useHttpRequestService must be used within a HttpRequestProvider');
    }
    return httpRequestService;
};
